/**
 * Customer Types - Main Export
 * Central export point for all customer-related types
 */

// Import specific types for union type
import { Condominio } from './condominio';
import { Empresa } from './empresa';
import { Fabrica } from './fabrica';

// Base types
export * from './base';
export * from './condominio';
export * from './empresa';
export type { Fabrica } from './fabrica';

// Union type for all customer types
export type Customer = Condominio | Empresa | Fabrica;

// Type guards
export function isCondominio(customer: Customer): customer is Condominio {
  return customer.type === 'condominio';
}

export function isEmpresa(customer: Customer): customer is Empresa {
  return customer.type === 'empresa';
}

export function isFabrica(customer: Customer): customer is Fabrica {
  return customer.type === 'fabrica';
}

// Helper to get customer type display name
export function getCustomerTypeLabel(type: string): string {
  const labels: Record<string, string> = {
    condominio: 'Condomínio',
    empresa: 'Empresa',
    fabrica: 'Fábrica',
  };
  return labels[type] || type;
}

// Helper to get empresa subtype display name
export function getEmpresaSubtypeLabel(subtype: string): string {
  const labels: Record<string, string> = {
    fabrica: 'Fábrica',
    escritorio: 'Escritório',
    comercio: 'Comércio',
    industria: 'Indústria',
    outro: 'Outro',
  };
  return labels[subtype] || subtype;
}
